export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

/**
 * Sprint 4 — Rejection codes (TALAPP-1594)
 * Catalog of reasons a compliance reviewer or pipeline can use when
 * rejecting a document. Persisted in audit_logs.details and surfaced in UI.
 */
export const REJECTION_CODES = {
  WRONG_TYPE: "WRONG_TYPE",
  ILLEGIBLE: "ILLEGIBLE",
  EXPIRED: "EXPIRED",
  INCOMPLETE: "INCOMPLETE",
  MISMATCH_DATA: "MISMATCH_DATA",
  OTHER: "OTHER",
} as const;

export type RejectionCode = typeof REJECTION_CODES[keyof typeof REJECTION_CODES];
